import * as Yup from 'yup'

export const validationSchemas = (isFechas) => {
  let validationObject = { };
  validationObject["tipoDescarga"] = Yup.string().required('Este campo es obligatorio');
  
  if(isFechas){
    //validationObject["fechadesde"] = Yup.date().required('El campo es obligatorio.').max(Yup.ref('fechahasta'), 'Fecha desde debe ser menor a la fecha hasta.');
    //validationObject["fechahasta"] = Yup.date().required('El campo es obligatorio.').max(new Date(), 'Fecha hasta no puede ser mayor a la fecha actual.');
   //validationObject["fechadesde"] = Yup.string().required('El campo es obligatorio.');
    //validationObject["fechahasta"] = Yup.string().required('El campo es obligatorio.');
    validationObject["criterioFecha"] = Yup.string().required('Este campo es obligatorio');
  }

  return Yup.object().shape(validationObject);
}

